export default [
  {
    path: '/domain-system',
    name: 'DomainSystem',
    component: () => import('@/layouts/main.vue'),
    redirect: { name: 'DomainSystemManage' },
    children: [
      {
        path: 'domain-manage/list',
        name: 'DomainSystemManage',
        component: () => import('@/views/domain-system/domain-manage/list.vue'),
        meta: {
          title: '域名管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'log-manage/list',
        name: 'DomainLogManage',
        component: () => import('@/views/domain-system/log-manage/list.vue'),
        meta: {
          title: '日志管理',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
